module.exports = __webpack_public_path__ + "static/dental-care-logo-00495b86ff1860fd33ef3f7ab03b1667.png";